import forEach from 'lodash/forEach';
import remove from 'lodash/remove';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import TextButton from '@spothero/ui/text-button';
import FavoriteAPI from 'api/favorite';
import {userUpdate} from 'user/user-actions';
import Icon from 'common/icon/Icon';

class SaveAsFavorite extends Component {
    static propTypes = {
        className: PropTypes.string,
        user: PropTypes.object,
        spotId: PropTypes.number.isRequired,
        onUserUpdate: PropTypes.func.isRequired,
        onSaved: PropTypes.func
    };
    state = {
        isFavorite: false,
        prevSpotId: null
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            user: {
                favorites
            },
            spotId
        } = nextProps;

        if (prevState.prevSpotId !== spotId) {
            let shouldBeFavorite = false;

            forEach(favorites, favorite => {
                if (favorite.id === spotId) {
                    shouldBeFavorite = true;
                }
            });

            return {
                isFavorite: shouldBeFavorite
            };
        }

        return null;
    }

    componentDidMount() {
        const {
            spotId,
            user: {
                favorites
            }
        } = this.props;

        forEach(favorites, favorite => {
            if (favorite.id === spotId) {
                this.setState({
                    isFavorite: true
                });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            spotId,
            onSaved
        } = this.props;
        const {
            isFavorite
        } = this.state;

        if (prevState.isFavorite !== isFavorite && onSaved) {
            onSaved({
                spotId,
                isFavorite
            });
        }
    }

    _onClick = evt => {
        evt.preventDefault();

        const {
            spotId,
            user,
            onUserUpdate
        } = this.props;
        const {
            id,
            favorites
        } = user;
        const isFavorite = !this.state.isFavorite;

        FavoriteAPI
            .update({
                userId: id,
                facilityId: spotId,
                isFavorite
            })
            .then(response => {
                if (isFavorite) {
                    favorites.push({id: spotId});
                } else {
                    remove(favorites, favorite => {
                        return favorite.id === spotId;
                    });
                }

                this.setState({
                    isFavorite
                });

                onUserUpdate({
                    ...user,
                    favorites
                });
            })
            .catch(() => {
                // prevent uncaught promise errors in console
            });
    }

    render() {
        const {
            className
        } = this.props;
        const {
            isFavorite
        } = this.state;
        const classes = classNames(
            'SaveAsFavorite',
            {on: isFavorite},
            className
        );

        return (
            <TextButton
                className={classes}
                onClick={this._onClick}
            >
                <Icon name="heart" /> {`Save${(isFavorite) ? 'd' : ''} as Favorite`}
            </TextButton>
        );
    }
}

const mapStateToProps = state => {
    const {
        user: {
            data: user
        }
    } = state;

    return {
        user
    };
};

const mapDispatchToProps = {
    onUserUpdate: userUpdate
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveAsFavorite);
